"use strict";
//import smoothscroll from "smoothscroll-polyfill";
import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import { smoothScrollbarInit } from "./smoothScrollbar/smoothScrollbar";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
//import { mobileMenu } from "./mobileMenu/mobileMenu";
import { mainMenuClass } from "./mainMenu/mainMenu";
import { mainPageBaner } from "./mainPageBaner/mainPageBaner";
import { headerAnimation } from "./headerAnimation/headerAnimation";
import { popUp } from "./popUp/popUp";
import { pageBaner } from "./pageBaner/pageBaner";
import { animationInIfVisible } from "./animationIn/animationInIfVisible";
import { lazyLoadImage } from "./lazyLoading/lazyLoading";
import { addVideoToPage } from "./addVideoToPage/addVideoToPage";
import { ajaxFormClass } from "./form/form";
//import { mouseOverElement } from "./mouseOver/mouseOver";
import { showMoreInfo } from "./showMoreInfo/showMoreInfo";
//import { showHideSearchForm } from "./search/search";
//import { animationInIfVisible } from "./animationIn/animationInIfVisible";
import { goToFirstSection } from "./scrollToSection/scrollToFirstSection";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  if (!isMobile() && !document.body.classList.contains("macos"))
    window.smoothScroll = smoothScrollbarInit({ damping: 0.1 });

  fullSiteMenuInit();
  faqList();
  powieksz_zdjecie();
  akceptacja_ciasteczka();
  pageScroled();
  forms();

  //showHideSearchForm();

  if (!isMobile()) animationInInit();

  if (isMobile()) {
    $("body").addClass("mobile");
  }

  headerAnimation();
}

function afterLoadStart() {
  mainPageBanerInit();
  pageBanerInit();
  //scrollToElementInit();
  //mainPageBanerShow();
  popUp();
  addVideoToPage();
  lazyLoadImage(document.querySelectorAll("[data-images]"));
  //if (!isMobile()) mouseOverElement(document.querySelectorAll(".mouse-over"));
  addObserverToVideoInBaner();
  goToFirstSection();
  showMoreInfoInit();
}

function resize() {
  pageScroled();
}

function scroll() {
  pageScroled();
}

/*----- CODE BELOW -----*/
function animationInInit() {
  let elements = document.querySelectorAll(".animation-in-observer");
  animationInIfVisible({ elements, threshold: 0.1 });
}

function showMoreInfoInit() {
  const elements = document.getElementsByTagName("body");

  Array.from(elements).forEach((elm) => {
    new showMoreInfo({
      mainContainer: elm,
    });
  });
}

function forms() {
  let ajaxForms = $(".ajax-form");

  ajaxForms.each((idx, form) => {
    new ajaxFormClass(form);
  });
}

function mainPageBanerInit() {
  const banerTxt = document.getElementById("main-page-baner--txt");
  if (banerTxt) {
    new mainPageBaner(banerTxt);
  }
}

function pageBanerInit() {
  const elements = document.querySelectorAll(".page-baner-container");
  elements.forEach((element) => {
    new pageBaner(element);
  });
}

function fullSiteMenuInit() {
  window.fullSiteMenu = new mainMenuClass();
}

// function mobileMenuInit() {
//   window.mobileMenu = new mobileMenu();
// }

/*
function backgroundPhotoSlideInit() {
  const elements = document.querySelectorAll(".background-photo-slider");
  elements.forEach((element) => {
    new backgroundPhotoSlider(element);
  });
}
*/

function powieksz_zdjecie() {
  powieksz_video();

  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

function powieksz_video() {
  const tab = $("a.inline-video");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.inline-video").colorbox({
      inline: true,
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function (e) {
        const colorbox = document.getElementById("colorbox");
        if (colorbox.getElementsByTagName("video").length > 0) return;
        addVideoToPage(colorbox, "colorbox-video-container");
        //video[0].play();
        //video[0].controls = true;
        //video[0].loop = false;
      },
    });
  }
}

function showHideList() {
  let lists = $(".show-hide-list");

  lists.each((idx, list) => {
    $(list).find(".show-hide-list__hidden-element").hide();
    $(list)
      .children("li")
      .on("click", function () {
        if (!$(this).hasClass("show")) {
          $(this).addClass("show");
          $(this).find(".show-hide-list__hidden-element").slideDown();
        } else {
          $(this).removeClass("show");
          $(this).find(".show-hide-list__hidden-element").slideUp();
        }
      });
  });
}

function faqList() {
  let lists = $(".faq-list .faq-list__item");

  lists.each((idx, list) => {
    $(list).find(".faq-list__description").hide();
    $(list)
      .children(".faq-list__title")
      .on("click", function () {
        if (!$(this).parent().hasClass("show")) {
          $(this).parent().addClass("show");
          $(this).next(".faq-list__description").slideDown();
        } else {
          $(this).parent().removeClass("show");
          $(this).next(".faq-list__description").slideUp();
        }
      });
  });
}

/*----- CIASTECZKA -----*/
function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });

  let elm = $(".akceptuje-ciasteczka");
  if (elm.length == 0) return;

  addEvent(elm[0], "click", (e) => {
    e.preventDefault();
    console.log("akceptuje-ciasteczka");
    $.post("/ciasteczka", { akceptacja: 1 });
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}

function pageScroled() {
  const className = "page-scrolled";
  const scrollBreakPoint = 10;

  let scroll = 0;
  if (window.smoothScroll) {
    window.smoothScroll.addListener(({ offset }) => {
      scroll = offset.y;
      document.body.style.setProperty("--offsetY", scroll + "px");
      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  } else {
    scroll = $(window).scrollTop();
    document.body.style.setProperty("--offsetY", scroll + "px");
    if (scroll >= scrollBreakPoint) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }
}

function addObserverToVideoInBaner(config = {}) {
  const { root, threshold } = config;

  const elementsContainer = document.getElementById("baner-background");
  if (!elementsContainer) return;

  const elementsVideo = elementsContainer.getElementsByTagName("video");
  if (elementsVideo.length == 0) return;

  const options = {
    root: root ? root : null,
    threshold: threshold ? threshold : 0.1,
    rootMargin: "10px",
  };

  const elements = [elementsContainer];

  if (!elements) {
    elements = [];
  }

  elements.forEach((element) => {
    const elementsVideo = elementsContainer.getElementsByTagName("video");
    if (elementsVideo[0]) elementsVideo[0].pause();
  });

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const elementsVideo = elementsContainer.getElementsByTagName("video");
        elementsVideo[0].play();
      } else {
        const elementsVideo = elementsContainer.getElementsByTagName("video");
        elementsVideo[0].pause();
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  elements.forEach((element) => {
    observer.observe(element);
  });
}
